import React from "react";
import { Spinner } from "react-bootstrap";
import "./loadingNotification.css";

const Loading = ()=>{
    return(
    <div className="loadingContainer">
        <Spinner animation="grow">

        </Spinner>
        <h3>Carregando...</h3>
    </div>
    )
}

export default Loading;